module.exports = __webpack_public_path__ + "static/media/29FUNOV11.fd3d3e9d.jpg";